import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cp-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
